import React from 'react';
import { Popover } from 'antd';
import styled from 'styled-components';

import { getTextInitials } from '../common/helpers';

import { StyledRow } from './StyledRow';

const StyledContainer = styled(StyledRow)`
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  padding-top: 11px;
  padding-bottom: 11px;
  align-items: center;
  justify-content: center;
`;

const StyledAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 24px;
  width: 24px;
  font-size: 12px;
  color: #ffffff;
  cursor: pointer;
  line-height: 1;
`;

type Hsl = [number, number, number];
type Range = [number, number];

const sRange: Range = [30, 50];
const lRange: Range = [50, 70];
const hRange: Range = [0, 360];

const buildStringHash = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = Math.abs(hash);
  return hash;
};

const normalizeHash = (hash: number, min: number, max: number): number => {
  return Math.floor((hash % (max - min)) + min);
};

const generateHsl = (name: string, saturationRange: Range, lightnessRange: Range, hueRange: Range): Hsl => {
  const hash = buildStringHash(name);
  const h = normalizeHash(hash, hueRange[0], hueRange[1]);
  const s = normalizeHash(hash, saturationRange[0], saturationRange[1]);
  const l = normalizeHash(hash, lightnessRange[0], lightnessRange[1]);
  return [h, s, l];
};

const buildHslString = (hsl: Hsl) => {
  return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
};

const generateColorHsl = (id: string, saturationRange = sRange, lightnessRange = lRange) => {
  return buildHslString(generateHsl(id, saturationRange, lightnessRange, hRange));
};

export const UserAvatar: React.FC<{ userName: string; withPopover?: boolean }> = ({
  userName,
  withPopover = false,
}) => {
  if (!userName || userName === ' ') return <></>;

  const avatarColor = generateColorHsl(userName);
  const Avatar = <StyledAvatar style={{ backgroundColor: avatarColor }}> {getTextInitials(userName)}</StyledAvatar>;

  return <>{withPopover ? <Popover content={userName}>{Avatar}</Popover> : Avatar}</>;
};

export const InitialsBadgeTableCell: React.FC<{ userName: string }> = ({ userName }) => (
  <StyledContainer>
    <UserAvatar userName={userName} withPopover />
  </StyledContainer>
);
